import { useState } from "react";

import { toPhone } from "common/utils/formatting";
import { useMatch } from "common/router/hooks";
import { parseNumber } from "common/utils/numbers";

import StreamlinedHeader from "client/common/components/header/StreamlinedHeader";
import Page from "client/common/components/layouts/Page";
import { useClinic } from "client/clinics/hooks";
import { Paths } from "client/routes";

import CarePlanPaymentUpdateForm from "./CarePlanPaymentUpdateForm";
import CarePlanPaymentUpdateSuccessPage from "./CarePlanPaymentUpdateSuccessPage";

import styles from "../styles/CarePlanPaymentUpdatePage.module.less";

const CarePlanPaymentUpdatePage = () => {
  const match = useMatch<Paths["carePlans"]["paymentUpdate"]>();
  const matchSearch = match.search.patient_care_ids ?? "";
  const patientCareIds = matchSearch.split(",").map((id) => parseNumber(id));
  const [isConfirmed, setIsConfirmed] = useState(false);

  const clinic = useClinic();

  return (
    <Page Header={<StreamlinedHeader hasPrevious={false} />} Footer={null} className={styles.page}>
      <div className={styles.background} />
      <div className={styles.container}>
        <div className={styles.subcontainer}>
          {isConfirmed ? (
            <CarePlanPaymentUpdateSuccessPage />
          ) : (
            <>
              <div className={styles.content}>
                <div className={styles.title}>Update care plan payment method</div>
                <div className={styles.body}>
                  {/* TODO: Add in which care plans are affected */}
                  Your card will be charged automatically for any failed care plan payments upon
                  payment method update.
                </div>
                <div className={styles.body}>
                  Need help? Call us at <strong>{toPhone(clinic.phone_number)}</strong>.
                </div>
              </div>
              <CarePlanPaymentUpdateForm
                patientCareIds={patientCareIds}
                onConfirm={setIsConfirmed}
              />
            </>
          )}
        </div>
      </div>
    </Page>
  );
};

export default CarePlanPaymentUpdatePage;
